var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.is_user_logged_in == 1)?_c('ChatApp'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }